import * as React from "react";
import { createUseStyles } from "react-jss";
import { getTheme } from "@warda/library-ui/theme";
import Toolbar from "@warda/library-ui/core/Toolbar";
import { isMobile } from "@warda/library-ui/utils/deviceUtils";
import { HTML_ID_DRAWERS } from "./constants";
import TenantLogo from "./TenantLogo";
const useStyles = createUseStyles({
    main: {
        height: "100vh",
        width: "100vw",
        position: "relative",
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        padding: isMobile() ? 0 : "0 15px 15px 15px",
        boxSizing: "border-box",
        backgroundColor: getTheme().colors.grayDrawer,
    },
    area: {
        flex: 1,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
    },
    areaContent: {
        position: "relative",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        borderRadius: isMobile() ? undefined : getTheme().borderRadius,
        border: isMobile()
            ? undefined
            : `1px solid ${getTheme().colors.grayBorder}`,
        backgroundColor: getTheme().colors.background,
        overflow: "hidden",
    },
});
const SharePageFrame = ({ innerToolbar, content, onLogoReady, }) => {
    const classes = useStyles({});
    return (React.createElement("div", { className: classes.main, id: HTML_ID_DRAWERS },
        React.createElement("div", { className: classes.area },
            React.createElement(Toolbar, null,
                React.createElement(TenantLogo, { style: { margin: "0px 10px" }, onLogoReady: onLogoReady }),
                innerToolbar),
            React.createElement("div", { className: classes.areaContent }, content))));
};
export default SharePageFrame;
